import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@bibliocommons/base-links';
import { checkedOutItemShape } from '@bibliocommons/bc-prop-types';

import { sendEContentAction, ECONTENT_ACTIONS } from 'app/helpers/econtent/nativeEContentBridge';

export class ThirdPartyReaderLink extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    // Inside the native app (eContent capability), hand "Read Now" to the native
    // reader instead of opening the third-party web reader. Otherwise fall through
    // to the existing href behavior.
    const { checkoutItem } = this.props;
    const handledByNative = sendEContentAction(ECONTENT_ACTIONS.OPEN, checkoutItem.get('metadataId'), {
      format: checkoutItem.get('format'),
      title: checkoutItem.getIn(['bib', 'briefInfo', 'title'], checkoutItem.get('bibTitle'))
    });
    if (handledByNative && event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
  }

  render() {
    const { checkoutItem, linkTag } = this.props;
    const LinkTag = linkTag || Link;

    return (
      <LinkTag
        target="_blank"
        href={checkoutItem.get('thirdPartyReaderUrl')}
        className="cp-third-party-reader-link"
        dataKey="third-party-reader-link"
        handleClick={this.handleClick}
      >
        <FormattedMessage id="open_in_third_party_reader" />
      </LinkTag>
    );
  }
}

ThirdPartyReaderLink.propTypes = {
  checkoutItem: checkedOutItemShape.isRequired,
  linkTag: PropTypes.func
};

export default ThirdPartyReaderLink;
